const LABEL_OUTSIDE_SIZE = [
  "small",
  "xsmall",
  "default"
];
function isSlotAvailable(size) {
  return LABEL_OUTSIDE_SIZE.some((sizeItem) => sizeItem === size);
}

export { isSlotAvailable };
//# sourceMappingURL=model.mjs.map
